import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { tableModel } from '../../../components/table/model/tableModel';
import { Router } from '@angular/router';
import { RequestedSignaturesService } from '../../../services/requested-signatures.service';
import { AlertaService } from '../../../services/alerta.service';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { findAreasCatalogAct, findDivisionsCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { FilterSignatures } from '../../../models/filters/filter-signatures';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'app-requested-signatures',
  standalone: false,
  templateUrl: './requested-signatures.component.html',
  styleUrl: './requested-signatures.component.css'
})
export class RequestedSignaturesComponent {

  @ViewChild(TableComponent) requestedignaturesTable:TableComponent | undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'Id',columnValue:'id'},
      {columnName:'Number',columnValue:'number'},
      {columnName:'Estado',columnValue:'status'},
      {columnName:'Folio',columnValue:'folio'},
      {columnName:'Nombre',columnValue:'fullName'},
      {columnName:'Tipo Oferta',columnValue:'typeOfferDes'},
      {columnName:'Estado Oferta',columnValue:'statusDescription'}],
    dataSource: [],
    editButton:true
  };
  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  divisions: Division[] = [];
  areas: Area[] = [];
  filterSignatures: FilterSignatures = new FilterSignatures;
  advancedSearch: boolean = false;

  private requestedSignaturesService = inject(RequestedSignaturesService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);


  ngOnInit(): void {
    this.filterSignatures = new FilterSignatures();
    this.filterSignatures.ac = 1;
    this.searchSignaturesPaginator();
    
    this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
    this.catalogOfferStore.dispatch(findAreasCatalogAct());
  }

  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchSignaturesPaginator();
  }

  editEvent(event: any){
    this.loading = true;
    this.router.navigate(['/requestedSignatures/review', event.id]);
  }

  searchSignaturesPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchSignaturesPaginator();
  }
  searchSignaturesPaginator(){
    this.loading = true;

    this.requestedSignaturesService.findAllPageableSignaturesReq(this.filterSignatures, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.requestedignaturesTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }


  constructor(
    private catalogOfferStore: Store<{catalogOfferRdc: any}>
  ){
    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({
        divisions: state.divisions,
        areas: state.areas,
      })),
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ divisions, areas}) => {
      this.divisions = divisions;
      this.areas = areas;
    });
  }

}
